<template>
  <div>
    <b-row>
      <b-col
          md="2"
          sm="4"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="4"
          sm="8"
          class="my-1"
      />

      <b-col
          md="6"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Kennzeichen oder Ähnl."
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
            <b-button
                size="sm"
                class="ml-2 btn-success"
                @click="Add"
            >
              Neues Fahrzeug anlegen
            </b-button>
          </b-input-group>
        </b-form-group>

      </b-col>

      <b-col cols="12">
        <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="vehicles"
            :fields="fields"
            @row-clicked="ClickRow"
        >
          <template #cell(Action)="data">
            <b-button
              variant="info"
              class="btn-block btn-sm"
              @click="OpenStatistics(data.item.VId)"
            >
              Statistik
            </b-button>
          </template>
        </b-table>
      </b-col>

      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>

    <b-modal
        hide-footer
        id="modal-edit-vehicle"
        centered
        size="lg"
        :title="modalText"
    >
      <b-row>
        <b-row>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Name"
            >
              <b-form-input
                  v-model="edit.name" />
            </b-form-group>
          </b-col>

          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Kennzeichen"
            >
              <b-form-input
                  v-model="edit.numberPlate"/>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Km-Stand"
            >
              <b-form-input
                  v-model="edit.km" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
              md="3"
              xl="3"
              class="mb-1"
          >
            <b-form-group
                label="Nächste HU/AU"
            >
              <b-input-group>
                <cleave
                    id="date"
                    v-model="edit.nextHu"
                    class="form-control form-control-sm"
                    :raw="false"
                    :options="options.date"
                    placeholder="DD.MM.YY"
                    ref="nextHu"
                    @keyup.native="NumberOnlyAndAddDay($event)"
                    size="sm"
                />
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col
              md="3"
              xl="3"
              class="mb-1"
          >
            <b-form-group
                label="Nächster Öl wechsel"
            >
              <b-input-group>
                <cleave
                    id="date"
                    v-model="edit.nextOil"
                    class="form-control form-control-sm"
                    :raw="false"
                    :options="options.date"
                    placeholder="DD.MM.YY"
                    ref="nextOil"
                    @keyup.native="NumberOnlyAndAddDay($event)"
                    size="sm"
                />
              </b-input-group>
            </b-form-group>

          </b-col>
          <b-col
              md="3"
              xl="3"
              class="mb-1"
          >
            <b-form-group
                label="Reifengröße"
            >
              <b-form-input
                  v-model="edit.tires" />
            </b-form-group>
          </b-col>
          <b-col
              md="2"
              xl="2"
              class="mb-1"
          >
            <b-form-group
                label="Sitze"
            >
              <b-form-input
                  v-model="edit.seats" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-row>

      <div>
        <b-button
            size="sm"
            variant="gradient-danger"
            class="btn-icon"
            @dblclick="DeleteRow"
        >
          <feather-icon icon="Trash2Icon" />
        </b-button>
        <b-button class=float-right variant="success" @click="Save">
          OK
        </b-button>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BFormDatepicker
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Cleave from 'vue-cleave-component'

export default {
  name: 'Vehcile',
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormDatepicker,
    Cleave
  },
  data() {
    return {
      options: {
        Time2Label: 'Datum',
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'y'],
        },
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },
      },
      edit: {
        vId: 0,
        name: "",
        numberPlate: "",
        km: 0,
        nextHu: new Date(),
        nextOil: new Date(),
        tires: "",
        seats: 0
      },
      modalText: 'Neues Fahrzeug',
      currentPage: 1,
      totalRows: 0,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterTimeout: null,
      vehicles: [],
      fields: [
        {
          key: 'VId',
          label: 'ID',
        },
        {
          key: 'Name',
          label: 'Name',
        },
        {
          key: 'NumberPlate',
          label: 'Kennzeichen',
        },
        {
          key: 'Km',
          label: 'Kilometerstand',
        },
        {
          key: 'NextHu',
          label: 'Hu',
          formatter: (value, key, item) => {
            return `${new Date(value).toLocaleString('de-DE', {
                  year: '2-digit',
                  month: '2-digit'
                },
            )}`
          }
        },
        {
          key: 'NextOil',
          label: 'Öl',
          formatter: (value, key, item) => {
            return `${new Date(value).toLocaleString('de-DE', {
                  year: '2-digit',
                  month: '2-digit'
                },
            )}`
          }
        },
        {
          key: 'Tires',
          label: 'Reifen',
        },
        {
          key: 'Action',
          label: '',
        },
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Fahrzeuge'
    })
    this.LoadList()
  },
  methods: {
    OpenStatistics(id) {
      console.log(id)
      this.$router.push({
        name: 'StatsVehicle',
        params: { id: id }
      })
    },
    LoadList() {
      console.log('Test')
      this.$http.get(`/vehicle/list`)
          .then(resp => {
            this.vehicles = resp.data
          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadRow() {

    },
    DeleteRow() {

    },
    Reset() {
      this.edit = {
        vId: 1,
        name: "",
        numberPlate: "",
        km: 0,
        nextHu: new Date(),
        nextOil: new Date(),
        tires: "",
        seats: 1
      }
    },
    NumberOnlyAndAddDay(ev) {
      const isNumber = /^[0-9]$/i.test(ev.key)
      if (ev.key == '+' || ev.key == '-') {
        const date = this.vData.TravelDay.split('.')
        if (date[0].length == 2 && date[1].length == 2 && date[2].length == 2) {
          let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
          if (ev.key == '+') {
            TravelDay.setDate(TravelDay.getDate() + 1)
          }
          if (ev.key == '-') {
            TravelDay.setDate(TravelDay.getDate() - 1)
          }

          this.vData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit'
              },
          )
          this.TravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
                weekday: 'long',
              },
          ) + ','

        }
      }
      return false
    },
    Save() {
      let editVeh = Object.assign({}, this.edit)

      let date =  editVeh.nextHu.split('.')
      editVeh.nextHu = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])

      date =  editVeh.nextOil.split('.')
      editVeh.nextOil = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])

      console.log(editVeh)
      this.$http.post('vehicle/update', JSON.stringify(editVeh))
          .then(resp => {
            if (resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Fahrzeug wurde gespeichert.',
                  variant: 'success',
                },
              })
              this.LoadList()
              this.$bvModal.hide('modal-edit-vehicle')

            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })


    },
    Add() {
      this.modalText = "Neues Fahrzeug"
      this.Reset();
      this.$bvModal.show('modal-edit-vehicle')
    },
    ClickRow(record, index) {
      this.modalText = "Fahrzeug bearbeiten ("+record+")"


      this.edit = {
        vId: record.VId,
        name: record.Name,
        numberPlate: record.NumberPlate,
        km: record.Km,
        nextHu: new Date(record.NextHu).toLocaleString('de-DE', {
              year: '2-digit',
              month: '2-digit',
              day: '2-digit'
            },
        ),
        nextOil: new Date(record.NextOil).toLocaleString('de-DE', {
              year: '2-digit',
              month: '2-digit',
              day: '2-digit'
            },
        ),
        tires: record.Tires,
        seats: record.Seats
      }
      this.$bvModal.show('modal-edit-vehicle')
    }
  }
}
</script>

<style scoped>

</style>
